<main class="page-container">
  <div class="float-card-container">
    <app-demo-float-card></app-demo-float-card>
  </div>
</main>
